import { useState, useEffect } from "react";
import moment from "moment";
import { http } from "../core/Api";
import { SUBSCRIPTION_KEY } from "../core/storageKeys";

export const useServerTime = () => {
    const [serverTime, setServerTime] = useState(null);

    useEffect(() => {
        try {
            const before = new Date();
            http(`api/backend/v2/time`, "GET").then((response) => {
                const after = new Date();

                const diff = after - before;
                setServerTime(moment(response).valueOf() + diff);
            });
        } catch (e) {
        }
    }, []);

    return [serverTime, setServerTime];
};

export const getServerTime = async () => {
    try {
        const before = new Date();
        const serverTime = await http(`api/backend/v2/time`, "GET");
        const after = new Date();
        const diff = after - before;
        return serverTime + diff;
    } catch (e) {
    }
};

export const useSimuladao = () => {
    const [simuladao, setSimuladao] = useState(null);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        try {
            http(`api/backend/v2/simulatedfree`, "GET").then((response) => {
                if (!response.error) {
                    setSimuladao(response);
                }
                setLoading(false);
            });
        } catch (e) {
            setSimuladao(null);
            setLoading(false);
        }
    }, []);

    return [simuladao, setSimuladao, isLoading];
};

export const useOpenSimuladao = (simulated, redirect) => {
    const [simuladao, setSimuladao] = useState(null);
    const [history, setHistory] = useState({});
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    useEffect(() => {
        const rout = `api/backend/v2/simulatedlanding/verify/started`;
        const user = localStorage.getItem(SUBSCRIPTION_KEY);
        if (!user) {
            console.error("Usuário não encontrado");
            setLoading(false);
            return;
        }

        http(rout, "POST", { simulated: simulated, user: JSON.parse(user) })
            .then((response) => {
                // Falha de backend: o http() resolve com { error } (offline/rede)
                // ou com o objeto Response cru (HTTP != 2xx). NÃO redirecionamos
                // nesses casos — a landing (/simulado) reenviaria o usuário pra cá,
                // gerando loop infinito. Sinaliza erro pra tela exibir um retry.
                const backendFailed =
                    !response ||
                    response.error ||
                    typeof response.json === "function";

                if (backendFailed) {
                    setError(true);
                    setLoading(false);
                    return;
                }

                // Backend respondeu, mas o usuário não tem este simulado: aí sim
                // volta pra landing (que encaminha pro simulado canônico).
                if (!response.simulated) {
                    redirect.push("/simulado");
                    return;
                }

                setHistory(response.history);
                setSimuladao(response.simulated);
                setLoading(false);
            })
            .catch(() => {
                // Erro inesperado (ex.: JSON inválido): trata como falha, sem redirect.
                setError(true);
                setLoading(false);
            });
    }, []);

    return [simuladao, setSimuladao, history, setHistory, isLoading, error];
};

export const goToSimuladao = (user, history) => {
    var data_array = [
        { name: "email", value: user.email },
        { name: "identificador", value: "acessar_simuladao_2021_iii" },
        { name: "token_rdstation", value: "1fabfb1b8a6b5ebeb8994294173004eb" },
    ];
    window.RdIntegration.post(data_array);
    history.push("/simulado");
};

export const verifyLinkSimulation = (rankingEndDate) =>
    new Date(rankingEndDate) <= new Date();
